module.exports = __webpack_public_path__ + "img/ZB52_04.3b653004.jpg";